import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/eva-digital-exp-ui/eva-digital-exp-ui/apps/web/components/PropertiesSearch/PropertiesSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/eva-digital-exp-ui/eva-digital-exp-ui/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
